var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotifyFailure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.985.003a12.2 12.2 0 0 0-8.51 3.653A11.8 11.8 0 0 0 .002 12.21a11.78 11.78 0 0 0 11.8 11.793h.214a12.11 12.11 0 0 0 11.986-12.21A11.767 11.767 0 0 0 11.985.004m-1.483 16.542a1.473 1.473 0 0 1 1.449-1.53h.027a1.526 1.526 0 0 1 1.523 1.47 1.476 1.476 0 0 1-1.45 1.53h-.026a1.53 1.53 0 0 1-1.523-1.47m.5-4.042v-6a1 1 0 1 1 2 0v6a1 1 0 0 1-2 0"
})));
export default SvgNotifyFailure;